import MenuButton from 'components/header/menu-button';
import Dropdown from 'components/dropdown';
import { useState } from 'react';
import styles from './style.module.scss';
import { buildClassName } from 'utils/build-class-name';
import EarthIcon from 'components/icon/earth-icon';
import { useIsMobile } from 'hooks/use-size-class';

type LocaleOption = {
  id: string;
  label: string;
  isLink: boolean;
  onClick?: () => void;
};

type LocaleSwitcherProps = {
  shouldRender: boolean;
  currentLocale: string;
  localeOptions: LocaleOption[];
  changeLocale: (code: string) => Promise<void>;
};

export function LocaleSwitcher({ 
  shouldRender,
  currentLocale,
  localeOptions,
  changeLocale,
}: LocaleSwitcherProps) {
  const [isOpen, setIsOpen] = useState(false);
  const isMobile = useIsMobile();
  const isLocaleCode = /^[a-zA-Z]{2}-[a-zA-Z]{2}$/.test(currentLocale);

  const onToggle = () => {
    setIsOpen(prev => !prev);
  };

  const onClose = () => {
    setIsOpen(false);
  };

  if (!shouldRender) {
    return null;
  }

  return (
    <MenuButton 
      className={buildClassName(
        styles.component, 
        isLocaleCode && !isMobile && styles.localeCode,
        isMobile && styles.iconOnly
      )} 
      onClick={onToggle}
      closeMenu={onClose}
      testId="locale-switcher"
    >  
      <div>
        <div id="locale-menu" className={styles.content}>
          {isMobile ? (
            <EarthIcon className={styles.icon} />
          ) : (
            currentLocale?.toUpperCase()
          )}
        </div>
        
        {isOpen && (
          <Dropdown 
            items={localeOptions.map(option => ({
              ...option,
              onClick: async () => {
                // Call optional onClick handler if provided
                if (option.onClick) {
                  option.onClick();
                }
                
                try {
                  await changeLocale(option.id);
                  onClose();
                } catch (error) {
                  console.error('Failed to change locale:', error);
                  // Keep dropdown open on error so user can try again
                }
              },
            }))}
            className={styles.dropdown} 
          />
        )}
      </div>
    </MenuButton>
  );
}